export const regionPriority = {
    NZ: 1,
    UK: 1,
    AU: 1,
    Global: 2,
};
